module.exports = "/images/vendor/esri-leaflet-geocoder/dist/search.png?bb282794407c03d090d54683f0568837";